import {DealLossMotiveDao} from '../../dao';
import {DealLossMotiveModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateDealLossMotive(
    userData: Record<string, string>,
    dealLossMotiveId: number,
    update: Record<string, any>
) {
    try {
        const result = await DealLossMotiveDao.updateDealLossMotiveById(userData.userToken, dealLossMotiveId, update);

        const resultParsed = DealLossMotiveModel.parseDealLossMotive(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
